export default __webpack_public_path__ + "static/media/ep1collage4.09da0883.jpg";